export const state = () => ({
  groupIndexingRuleList: [],
});
